export enum BrandSocialLinkTypeEnum {
    TWITTER = 'TWITTER',
    FACEBOOK = 'FACEBOOK',
    INSTAGRAM = 'INSTAGRAM',
    YOUTUBE = 'YOUTUBE',
    LINKEDIN = 'LINKEDIN',
    SNAPCHAT = 'SNAPCHAT',
    TIKTOK = 'TIKTOK',
    WEBSITE = 'WEBSITE',
    BLUESKY = 'BLUESKY',
}

export const brandSocialLinkToLabelStringMap = {
    [BrandSocialLinkTypeEnum.TWITTER]: 'X',
    [BrandSocialLinkTypeEnum.FACEBOOK]: 'Facebook',
    [BrandSocialLinkTypeEnum.INSTAGRAM]: 'Instagram',
    [BrandSocialLinkTypeEnum.YOUTUBE]: 'YouTube',
    [BrandSocialLinkTypeEnum.LINKEDIN]: 'LinkedIn',
    [BrandSocialLinkTypeEnum.SNAPCHAT]: 'Snapchat',
    [BrandSocialLinkTypeEnum.TIKTOK]: 'TikTok',
    [BrandSocialLinkTypeEnum.WEBSITE]: 'Website',
    [BrandSocialLinkTypeEnum.BLUESKY]: 'Bluesky',
};

export const labelStringToBrandSocialLinkToMap = {
    ['X']: BrandSocialLinkTypeEnum.TWITTER,
    ['Facebook']: BrandSocialLinkTypeEnum.FACEBOOK,
    ['Instagram']: BrandSocialLinkTypeEnum.INSTAGRAM,
    ['YouTube']: BrandSocialLinkTypeEnum.YOUTUBE,
    ['LinkedIn']: BrandSocialLinkTypeEnum.LINKEDIN,
    ['Snapchat']: BrandSocialLinkTypeEnum.SNAPCHAT,
    ['TikTok']: BrandSocialLinkTypeEnum.TIKTOK,
    ['Website']: BrandSocialLinkTypeEnum.WEBSITE,
    ['Bluesky']: BrandSocialLinkTypeEnum.BLUESKY
};


